import turfObj from "@turf/destination";

export default function destination(point, distance, bearing, options) {
    return turfObj(point, distance, bearing, options);
};
